<template>
  <div class="home-steps">
         <div class="home-box">
            <div class="steps-box" v-for="item in stepsList" :key="item.key">
                <div class="round-box" @click="changeActive(item.key)">
                    <div v-if="item.key < active" class="round40">
                      <div class="round-solid round20"></div>
                    </div>
                    <div v-else-if="item.key === active" class="round-shine-out round40">
                      <img v-if="item.key===stepsList.length && appointmentState" src="@/assets/images/checked.png" alt="" class="round20">
                      <div v-else class="round-shine round20"></div>
                    </div>
                    <div v-else-if="item.key > active" class="round40">
                      <div class="round-hollow round20"></div>
                    </div>
                    <div :class="item.key<=active?'steps-text c333':'steps-text c40'">
                      {{item.text}}
                    </div>
                </div>
                <div v-if="item.key!==stepsList.length" :class="item.key>=active?'dashedLien centerLine':'solidLien centerLine'"></div>
            </div>
         </div>
     </div>
</template>

<script>
// 顶部步骤条
export default {
    name:"HomeSteps",
    props:{
        active:{
            type: Number,
            default: 1,
            required: true,
            validator: function (value) {
              return value >= 1 
            }
        },
        stepsList:{
            type:Array,
            default:()=>{
              return[{
                key:1,
                text:"信息填报"
              },{
                key:2,
                text:"信息审核"
              },{
                key:3,
                text:"审核通过"
              }]
            }
        },
        appointmentState:{
          type: Boolean,
          default: false
        }
    },
    data(){
        return{
            // originalActive:"",
        }
    },
    mounted(){
      // //设置原始Active
      // const { auditState } = this.$route.query;
      // if(auditState==10){//未提交
      //   this.originalActive = 1;
      // }else if(auditState==20){//待审核
      //   this.originalActive = 3;
      // }else if(auditState==30){//驳回
      //   this.originalActive = 3;
      // }else if(auditState==40||auditState==50){//40通过50转正
      //   this.originalActive = 4;
      // }else{
      //   this.originalActive = 1;
      // }
    },
    methods:{
      changeActive(val){
        //active  1、信息填报 2、证件上传 3、信息审核 4、审核通过
        // 只有状态是2证件上传时才可以点击信息填报
        // 待审核（3）、驳回（3）、通过（4），不可点击
        if(this.active==2&&val==1){
          this.$emit('changeActive',1)
        }
      }
    }
}
</script>

<style lang='less' scoped>
.home-steps {
    height: 146px;
    padding-left:70px;
    padding-right:70px;
    border-radius:14px;
    background: #fff;
    display: flex;
    margin-bottom: 17px;
    .c333{
      color: #333333;
    }
    .c40{
      color: rgba(0,0,0,0.40);
    }
    .home-box{
        flex:1;
        margin-top: 29px;
        align-self: flex-start;  
        display: flex;
    }
    .steps-box{
        flex:1;
        display: flex;
        align-items: center;
    }
    .steps-box:last-of-type{
        max-width: 46px;
    }
    .centerLine{
        flex:1;
        margin-left:-26px;
        margin-right:-26px;
    }
    .solidLien{
        border-top:2px solid #176AF0;
    }
    .dashedLien{
        border-top:2px dashed #176AF0;
    }
    .steps-text{
        position: absolute;
        margin-top:8px;
        margin-left: -28px;
        font-family: PingFangSC-Medium;
        font-size: 26px;     
    }
    .round40{
        height: 46px;
        width: 46px;
        border-radius:50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .round20{
        height: 26px;
        width: 26px;
        border-radius:50%;
    }
    .round-shine-out{
        background: rgba(50,153,255,0.20);
    }
    .round-solid{
        background: #176AF0;
    }
    .round-shine{
        background: #176AF0;
    }
    .round-hollow{
        border: 2px solid #176AF0;
        background: #fff;
        z-index: 2;
    }
}
</style>
